module.exports = __webpack_public_path__ + "img/new-password-image.8f2b11af.png";